import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload } from '@fortawesome/pro-solid-svg-icons'
import styles from './FileTemplate.module.scss'

export interface TemplateProps {
  link?: string
  onDownload?: () => Promise<void>
  label: React.ReactNode
}

export const FileTemplate: React.FC<TemplateProps> = ({
  label,
  link,
  onDownload,
}) => {
  if (onDownload) {
    return (
      <button
        type="button"
        className={`${styles.bodyFont} ${styles.linkButton}`}
        onClick={onDownload}
      >
        <span>{label}</span>
        <FontAwesomeIcon
          icon={faFileDownload}
          className="mt-2 ml-2"
        ></FontAwesomeIcon>
      </button>
    )
  }
  return (
    <a
      className={styles.bodyFont}
      target="_blank"
      rel="noreferrer"
      href={link!}
    >
      <span>{label}</span>
      <FontAwesomeIcon
        icon={faFileDownload}
        className="mt-2 ml-2"
      ></FontAwesomeIcon>
    </a>
  )
}
